export default {
  onboarding: {
    stepWelcome: "Bienvenida",
    stepProducts: "Tus productos",
    stepCompetitors: "Competencia",
    stepSummary: "Resumen",
    catalogLoadError: "No se pudo cargar el catálogo. Inténtalo de nuevo.",
    saveError: "Error al guardar la configuración",
    welcomeTitle: "Bienvenido a HelixScan",
    welcomeBody1: "Vamos a configurar tu organización en 3 minutos: elegirás los ",
    welcomeStrong1: "productos de tu laboratorio",
    welcomeBody2: " desde el catálogo oficial CIMA (AEMPS) y los ",
    welcomeStrong2: "productos de tu competencia",
    welcomeBody3: " que quieres vigilar.",
    welcomeNote: "A partir de ese momento, cada cambio de precio, financiación o seguridad que afecte a tus productos o a tu competencia se marcará y priorizará automáticamente.",
    readonlyNotice: "Tu usuario es de solo lectura: pide a un administrador de tu organización que complete la configuración.",
    startSetup: "Empezar configuración",
    later: "Lo haré más tarde",
    labStepTitle: "1 · Busca tu laboratorio",
    labStepDesc: "Catálogo oficial CIMA – AEMPS (25.000+ medicamentos). Puedes añadir productos de varios laboratorios.",
    labSearchPlaceholder: "Ej: Italfarmaco, Kern Pharma, Cinfa…",
    searching: "Buscando…",
    productFilterPlaceholder: "Filtrar productos…",
    selectMarketed: "+ Seleccionar comercializados",
    loadingCatalog: "Cargando catálogo…",
    alreadyInPortfolio: "ya en tu portfolio",
    notMarketed: "no comercializado",
    noFilterResults: "Sin resultados para este filtro",
    back: "Atrás",
    productsSelectedOne: "{n} producto seleccionado",
    productsSelectedMany: "{n} productos seleccionados",
    continue: "Continuar",
    competitorsStepTitle: "2 · Elige tu competencia",
    competitorsBody1: "Te sugerimos medicamentos comercializados con el ",
    competitorsStrong: "mismo principio activo",
    competitorsBody2: " que tus productos, de otros laboratorios. Selecciona los que quieras vigilar.",
    searchingCompetitors: "Buscando competidores en el catálogo…",
    noCompetitors: "No se han encontrado competidores directos en el catálogo. Podrás añadirlos manualmente en «Competidores».",
    removeAll: "Quitar todos",
    selectAll: "Seleccionar todos",
    compsSelectedOne: "{n} competidor",
    compsSelectedMany: "{n} competidores",
    summaryStepTitle: "3 · Resumen",
    portfolioProducts: "Productos de tu portfolio",
    competitorsToMonitor: "Competidores a vigilar",
    summaryNote: "Podrás añadir o quitar productos y competidores en cualquier momento desde el menú «Configuración».",
    saving: "Guardando…",
    finishSetup: "Finalizar configuración",
  },
};
